module.exports = __webpack_public_path__ + "img/Locked Icon - white.013f5393.svg";